import { render, staticRenderFns } from "./ModulePaperWallet.vue?vue&type=template&id=d4a0f03c"
import script from "./ModulePaperWallet.vue?vue&type=script&lang=js"
export * from "./ModulePaperWallet.vue?vue&type=script&lang=js"
import style0 from "./ModulePaperWallet.vue?vue&type=style&index=0&id=d4a0f03c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports